import React, { memo } from 'react';
import { ChangeEvent, ClickEvent } from '@roc-digital/ui-lib';
import { User } from '@roc-digital/mxm-base/dist/data';
import { BodyDark, BodyLight, Input, Pressable, Select, Spacer } from '@/components/elements';
import { Toggle } from '@roc-digital/ui-web';

type ViewerProps = {
  user?: User;
  clickEvent?: ClickEvent;
  changeEvent?: ChangeEvent;
  editMode?: boolean;
};

const Viewer = memo(({ user: viewer, clickEvent, changeEvent, editMode }: ViewerProps) => {
  return (
    <>
      <div className={'flex flex-row justify-between mt-4 mb-4'}>
        <BodyDark>UserId</BodyDark>
        <BodyLight>{viewer?.id}</BodyLight>
      </div>
      <Spacer />
      <div className={'flex flex-row justify-between mt-4 mb-4'}>
        <BodyDark>LoginType</BodyDark>
        <BodyLight>{viewer?.login_type || '-'}</BodyLight>
      </div>
      <Spacer />
      <div className={'flex flex-row justify-between mt-4 mb-4'}>
        <BodyDark>Status</BodyDark>
        <Pressable clickEvent={clickEvent}>
          <Select
            id={'state'}
            changeEvent={changeEvent}
            value={viewer?.state}
            size="x-small"
            options={[
              { label: 'Verified', value: 'verified' },
              { label: 'Not Verified', value: 'not_verified' },
            ]}
          />
        </Pressable>
      </div>
      <Spacer />
      <div className={'flex flex-row justify-between mt-4 mb-4'}>
        <BodyDark>Email</BodyDark>
        <Pressable clickEvent={clickEvent}>
          {editMode ? (
            <Input value={viewer?.email} changeEvent={changeEvent} id={'email'} />
          ) : (
            <BodyLight>{viewer?.email || '-'}</BodyLight>
          )}
        </Pressable>
      </div>
      <Spacer />
      <div className={'flex flex-row justify-between mt-4 mb-4'}>
        <BodyDark>Phone Number</BodyDark>
        <Pressable clickEvent={clickEvent}>
          {editMode ? (
            <Input value={viewer?.phone} changeEvent={changeEvent} id={'phone'} />
          ) : (
            <BodyLight>{viewer?.phone || '-'}</BodyLight>
          )}
        </Pressable>
      </div>
      <Spacer />
      <div className={'flex flex-row justify-between mt-4'}>
        <BodyDark>Comments</BodyDark>
        <Select
            id={'block_comments'}
            changeEvent={changeEvent}
            value={viewer?.block_comments ? 'true' : 'false'}
            size="x-small"
            options={[
              { label: 'Allowed', value: 'false'},
              { label: 'Blocked', value: 'true'},
            ]}
          />
      </div>
      <div className={'flex flex-row justify-between mt-4 mb-4'}>
        <BodyDark>Block Reason</BodyDark>
          {viewer?.block_comments ? <>
            <Input value={viewer?.block_comments_reason || ''} changeEvent={changeEvent} id={'block_comments_reason'} />
          </> : null}
      </div>
    </>
  );
});

Viewer.displayName = 'Viewer';

export default Viewer;
